/**
 * Non-Inventory Product Has Average Cost Exception Config
 *
 * Covers: ex-inv-ls-noninv-has-avg-cost
 *
 * Products flagged as non-inventory that still have an average cost
 * allocated at some outlet — typically a configuration error.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const noninvHasAvgCostConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-noninv-has-avg-cost'],
  primaryErrorCode: 'avg_cost_missing',
  // On this report a $0.00 avg cost is the CORRECT state (non-inventory
  // products shouldn't carry cost) - suppress the ⚠ zero-cost anomaly.
  outletExpectsCost: false,
})
